<template>
  <div>
    <div class="row">
      <div class="col">
        <div class="AdicionarImagem--header p-1">
          Demais Documentos
        </div>
      </div>
    </div>

    <div class="row p-2 m-0">
      <div class="col">
        <div class="row">
          <div class="col-5">
            <div>
              <div class="DropAreaSingle AdicionarImagem--border">
                <span v-if="showNameFiles && !!inputFiles()">
                  <b>Arquivo selecionado: </b>{{ showNameFiles && inputFiles() }}<br>
                  <small>Para trocar, arraste o arquivo PDF  aqui ou <label for="preparar-processo-imagem"><u>procure manualmente</u></label> para upload </small>
                </span>

                <span v-else>
                  Arraste o arquivo PDF aqui ou <label for="preparar-processo-imagem"><u>procure manualmente</u></label> para upload
                </span>
              </div>

              <input id="preparar-processo-imagem"
                     v-validate="{required: true, mimes: ['application/pdf']}"
                     type="file"
                     name="imagem"
                     accept="application/pdf"
                     class="form-control-sm form-control-file file"
                     @dragover="($event) => dragArea($event)"
                     @dragleave="($event) => dragAreaOut($event)"
                     @drop="drop()"
                     @change="showName">

              <label v-if="1 != 1"
                     for="preparar-processo-imagem"
                     class="label">Adicionar um documento</label>

              <div v-if="errors.has('imagem')"
                   class="text-center">
                <small class="text-danger">Upload obrigatório, certifique-se de estar escolhendo um documento <strong>PDF</strong></small>
              </div>
            </div>
          </div>
          <div class="col-2">
            <div class="form-group">
              <label for="imagem_tipo_documento"
                     class="label">
                Tipo de Documento
              </label>

              <select id="imagem_tipo_documento"
                      v-model="form.tipo_documento"
                      v-validate="`required`"
                      name="tipo_documento"
                      :class="{ 'is-invalid': errors.has('tipo_documento') }"
                      class="form-control form-control-sm">
                <option :value="null">
                  Selecione o tipo
                </option>
                <option>Comum</option>
                <option>Certidões</option>
              </select>
            </div>
          </div>
          <div class="col-3">
            <div class="form-group">
              <label for="imagem_tag"
                     class="label">Tag</label>
              <input id="imagem_tag"
                     v-model="form.tag"
                     v-validate="`required`"
                     name="tag"
                     :class="{ 'is-invalid': errors.has('tag') }"
                     type="text"
                     class="form-control form-control-sm">
            </div>
          </div>
          <div class="col-2">
            <div class="form-group">
              <label for="imagem_correspondente"
                     class="label">Correspondente a</label>

              <select id="imagem_correspondente"
                      v-model="form.correspondente"
                      v-validate="`required`"
                      name="correspondente"
                      :class="{ 'is-invalid': errors.has('correspondente') }"
                      class="form-control form-control-sm">
                <option :value="null">
                  Correspondente
                </option>
                <option>Ambos</option>
                <option>Cônjuge 1</option>
                <option>Cônjuge 2</option>
              </select>
            </div>
            <br>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col text-right mr-2 mb-2">
        <button class="btn btn-secondary btn-sm ml-2"
                @click="add()">
          Adicionar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  /* services */
  import UploadTemporarioService from "@/services/Arquivos/UploadTemporarioService"

  export default {
    name: "FormDocumentos",
    props: {
      propForm: {
        type: Object,
        default: () => { return {} }
      }
    },
    data () {
      return {
        showNameFiles: true,
        form: {
          anexado: false,
          url_s3: null,
          tipo_documento: null,
          tag: null,
          correspondente: null,
          obrigatorio: false
        }
      }
    },
    methods: {
      add () {
        this.$validator.validate().then(async (res) => {
          if (res) {
            try {
              loader({ text: "Aguarde, salvando...", active: true })
              await this.adicionarImagem()
              this.$emit('onAdd', this.form)
            } catch (e) {
              objSwal.error.title = "Erro ao salvar!"
              objSwal.error.text = ''
              Swal.fire(objSwal.error)
              throw "Não foi possível salvar o processo!"
            } finally {
              loader({ active: false })
            }
          }
        })

      },
      async adicionarImagem () {
        try {
          let form = new FormData()
          const arquivo = document.querySelector('.file')

          if (this.$route.name === 'habilitar_casamento') {
            form.append('tipo', 'rascunho')
            form.append('rascunho_id', this.$route.params.id)
          } else {
            form.append('tipo', 'registro')
            form.append('registro_id', this.$route.params.id)
          }
          
          form.append('file', arquivo.files[0])
          const upload = await UploadTemporarioService.uploadTemporario(form)

          if (upload.success == true) {
            this.form.url_s3 = upload.url_s3
          }
        } catch (e) {
          objSwal.error.title = "Erro ao fazer upload!"
          objSwal.error.text = ''
          Swal.fire(objSwal.error)
          throw "Não foi possível realizar o upload do arquivo temporário em AdicionarImagem" + e
        }
      },

      dragArea ($event) {
        const element = document.querySelector('.DropAreaSingle')
        element.classList.add('DropAreaDrag')
        $event.preventDefault()
      },

      dragAreaOut ($event) {
        const element = document.querySelector('.DropAreaSingle')
        element.classList.remove('DropAreaDrag')
        $event.preventDefault()
      },

      drop () {
        const element = document.querySelector('.DropAreaSingle')
        element.classList.remove('DropAreaDrag')
      },

      inputFiles () {
        const element = document.querySelector('.file')
        return element && element.files[0] && element.files[0].name || null
      },

      showName () {
        this.showNameFiles = false
        setTimeout(() => {
          this.showNameFiles = true
        }, 10)
      },
    }
  }
</script>

<style scoped lang="scss">
  @import "../../../../scss/app";

  .DropAreaSingle {
    height: 100px;
    padding: 5px;
    background-color: #f4f4f4;
    border:2px solid black;
    border-style: dashed;
  }

  .DropAreaDrag {
    height: 100px;
    padding: 5px;
    background-color: #3498db;
    color: #fff;
    border-color: #086AAE;
  }

  .file {
    height: 100px;
    padding: 5px;
    width: 94%;
    padding-top: 9%;
    background-color: #f4f4f4;
    border-color: #086AAE;
    opacity: 0;
    z-index: 10;
    position: absolute;
    top: 0;
  }
</style>
